/**
 * Payment Terms Display Component
 * Displays payment terms information with inheritance indicators
 */

import React from "react";
import {
  Box,
  Typography,
  Chip,
  Grid,
  Alert,
  Divider,
} from "@mui/material";
import { Info, AccountBalance } from "@mui/icons-material";

const PAYOUT_TRIGGER_LABELS = {
  FULL_PAYMENT: "Full Payment Required",
  DEPOSIT_ONLY: "Deposit Only",
  COMPLETION_PLUS_DAYS: "Completion + Days Delay",
  PAYDAY_ONLY: "Monthly Payday Only (No Advance)",
  PAYDAY_WITH_ADVANCE: "Monthly Payday (Advance Allowed)",
};

const PaymentTermsDisplay = ({ paymentTerms, source, inheritedFrom }) => {
  if (!paymentTerms) return null;

  return (
    <Box>
      {source === "inherited" && inheritedFrom && (
        <Alert severity="info" icon={<Info />} sx={{ mb: 2 }}>
          Inherited from partner: {inheritedFrom}
        </Alert>
      )}
      {source === "default" && (
        <Alert severity="warning" icon={<Info />} sx={{ mb: 2 }}>
          Using default payment terms (not configured)
        </Alert>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Payout Trigger
          </Typography>
          <Chip
            label={PAYOUT_TRIGGER_LABELS[paymentTerms.payoutTrigger] || paymentTerms.payoutTrigger}
            color="primary"
            size="small"
            icon={<AccountBalance />}
          />
          {paymentTerms.payoutTrigger === "COMPLETION_PLUS_DAYS" && paymentTerms.payoutDelayDays && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
              Delay: {paymentTerms.payoutDelayDays} days
            </Typography>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Retention Percentage
          </Typography>
          <Typography variant="h6">{paymentTerms.retentionPercent}%</Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Dispute Window
          </Typography>
          <Typography variant="body1">{paymentTerms.disputeWindowDays} days</Typography>
        </Grid>
        {source === "direct" && (
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="caption" color="text.secondary">
              Source: Direct configuration
            </Typography>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

export default PaymentTermsDisplay;
